import { Spin } from 'antd';

import { NotificationWebItem } from '../notifications.model';
import { NotificationEmptyState } from './notification-empty-state/notification-empty-state.component';
import { NotificationItem } from './notification-item/notification-item.component';
import * as Styled from './notification-list-content.style';

interface NotificationListContentProps {
  notifications: NotificationWebItem[];
  isLoading: boolean;
  onNotificationClick: (item: NotificationWebItem) => void;
  emptyTitle: string;
  emptyDescription: string;
}

const NotificationListContent = ({
  notifications,
  isLoading,
  onNotificationClick,
  emptyTitle,
  emptyDescription,
}: NotificationListContentProps) => {
  if (isLoading) {
    return (
      <Styled.LoadingState>
        <Spin />
      </Styled.LoadingState>
    );
  }

  if (notifications.length === 0) {
    return (
      <NotificationEmptyState
        title={emptyTitle}
        description={emptyDescription}
      />
    );
  }

  return (
    <>
      {notifications.map((item) => (
        <NotificationItem
          key={item.id}
          item={item}
          onClick={onNotificationClick}
        />
      ))}
    </>
  );
};

export { NotificationListContent };
